// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Exploding Fire",
  id: "exploding-fire",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire"],
    icon: {
      "backgroundColor": 4066319,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -14,
          "color": 15633767
        }
      ]
    },
  },
};

export default metadata;
